export default __webpack_public_path__ + "static/media/worldmap.e9deb7d4.svg";